import useNotification from "./hooks/useNotification";
import Notice from "./Notice";
import NotificationProvider from "./NotificationProvider";
export { useNotification, Notice, NotificationProvider };


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-notification/es/index.js
// module id = 416
// module chunks = 0